var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-data-table',{staticClass:"border",attrs:{"headers":_vm.headers,"items":_vm.items,"density":"compact","hide-default-header":_vm.noHeader,"hide-default-footer":""},scopedSlots:_vm._u([_vm._l((_vm.headers),function(header,index){return {key:`item.${header.value}`,fn:function({ item }){return [_c('td',{key:`${item.id}-${header.value}`,class:_vm.getColumnClass(index),style:({
        backgroundColor: _vm.PAYMENT_CERTIFICATE_TABLE_COLOR.BLUE,
        fontWeight: 500
      })},[_vm._v(" "+_vm._s(_vm.formatValue(item[header.value]))+" ")])]}}})],null,true)})
}
var staticRenderFns = []

export { render, staticRenderFns }